module.exports = __webpack_public_path__ + "static/media/GA_Post_do-posle.5fc39180.jpg";